import type {
  AttributionStoragePersistence,
  QueueStoragePersistence,
  SessionStoragePersistence,
  VisitorStoragePersistence,
} from '@/config/shared/persistence';

import { BrowserStorageAdapter } from './BrowserStorageAdapter';
import { MemoryStorageAdapter } from './MemoryStorageAdapter';
import type { StorageAdapter } from './types';

export type StoragePersistence =
  | VisitorStoragePersistence
  | SessionStoragePersistence
  | AttributionStoragePersistence
  | QueueStoragePersistence;

export function createStorageAdapter(
  persistence?: StoragePersistence
): StorageAdapter {
  const mode = persistence ?? 'memory';

  if (typeof window === 'undefined') {
    return new MemoryStorageAdapter();
  }

  switch (mode) {
    case 'memory':
      return new MemoryStorageAdapter();
    case 'localStorage':
      return new BrowserStorageAdapter(window.localStorage);
    case 'sessionStorage':
      return new BrowserStorageAdapter(window.sessionStorage);
    case 'cookie_localStorage':
      // TODO: implementar cookie fallback.
      return new BrowserStorageAdapter(window.localStorage);
    case 'cookie':
      return new MemoryStorageAdapter();
    case 'indexedDB':
      return new MemoryStorageAdapter();
    default:
      return new MemoryStorageAdapter();
  }
}

export function resolveStorageAdapterName(
  persistence?: StoragePersistence
): string {
  const mode = persistence ?? 'memory';

  switch (mode) {
    case 'localStorage':
    case 'sessionStorage':
    case 'cookie_localStorage':
      return 'BrowserStorageAdapter';
    default:
      return 'MemoryStorageAdapter';
  }
}
